import { put, takeLatest } from 'redux-saga/effects';
import appActions from '../../../appActions';
import { querySaga, querySagaDownload } from '../../../utils/reduxHelper';

function* resetDevOpsToolSaga() {
    yield put(appActions.EXPORTLOGS_RESET_SUCCESS());
}

function* watchDowloadFileLogsRequest() {
    yield takeLatest(
        appActions.EXPORTLOGS_GET_FILE_LOG_REQUEST.type,
        function* (action) {
            let ids = action.payload;
            yield* querySagaDownload(
                {...action, payload : null},
                `integration/export/file-logs/${ids}`,
                appActions.EXPORTLOGS_GET_FILE_LOG_SUCCESS,
                appActions.EXPORTLOGS_GET_FILE_LOG_FAILURE,
                'GET'
            );
        },
    );
}

function* watchDowloadTableLogsRequest() {

    yield takeLatest(
        appActions.EXPORTLOGS_GET_TABLE_LOG_REQUEST.type,
        function* (action) {
            yield* querySagaDownload(
                action,
                `integration/export/table-logs`,
                appActions.EXPORTLOGS_GET_TABLE_LOG_SUCCESS,
                appActions.EXPORTLOGS_GET_TABLE_LOG_FAILURE,
                'POST'
            );
        },
    );
}

function* watchCleanUpTableRequest() {
    yield takeLatest(
        appActions.EXPORTLOGS_CLEAN_UP_TABLE_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                `context/cron/cleanup-table`,
                appActions.EXPORTLOGS_CLEAN_UP_TABLE_SUCCESS,
                appActions.EXPORTLOGS_CLEAN_UP_TABLE_FAILURE,
                'GET'
            );
        },
    );
}

function* watchCleanUpDiskRequest() {
    yield takeLatest(
        appActions.EXPORTLOGS_CLEAN_UP_DISK_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                `context/cron/cleanup-disk`,
                appActions.EXPORTLOGS_CLEAN_UP_DISK_SUCCESS,
                appActions.EXPORTLOGS_CLEAN_UP_DISK_FAILURE,
                'GET'
            );
        },
    );
}

function* watchCleanUpLogsRequest() {
    yield takeLatest(
        appActions.EXPORTLOGS_CLEAN_UP_LOG_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                `context/cron/cleanup-log`,
                appActions.EXPORTLOGS_CLEAN_UP_LOG_SUCCESS,
                appActions.EXPORTLOGS_CLEAN_UP_LOG_FAILURE,
                'GET'
            );
        },
    );
}

function* watchLogsParserRequest() {
    yield takeLatest(
        appActions.EXPORTLOGS_GET_LOG_PARSER_REQUEST.type,
        function* (action) {
            yield* querySaga(
                action,
                `context/log-parser`,
                appActions.EXPORTLOGS_GET_LOG_PARSER_SUCCESS,
                appActions.EXPORTLOGS_GET_LOG_PARSER_FAILURE,
                'GET'
            );
        },
    );
}

export default function* devOpsToolWatcher() {
    yield* watchDowloadFileLogsRequest();
    yield* watchDowloadTableLogsRequest();
    yield* watchCleanUpTableRequest();
    yield* watchCleanUpDiskRequest();
    yield* watchCleanUpLogsRequest();
    yield* watchLogsParserRequest();
    yield takeLatest(appActions.EXPORTLOGS_RESET_REQUEST.type, resetDevOpsToolSaga);
    // Add other watchers here
}
